import React from 'react'
import { Button } from 'syft-acp-atoms/Button'
import { DateRangeStepProps } from '../BulkShiftRateUpdateModal.types'

export const DateRangeStep: React.FC<DateRangeStepProps> = ({
  startDate,
  endDate,
  onStartDateChange,
  onEndDateChange,
  onNext,
  onCancel,
  loading,
}) => {
  const today = new Date().toISOString().split('T')[0]

  return (
    <div>
      <h2 style={{ marginBottom: '1rem' }}>Select Date Range</h2>

      <div style={{ marginBottom: '1rem' }}>
        <label htmlFor="start-date" style={{ display: 'block', marginBottom: '0.5rem' }}>
          <strong>Start Date (inclusive)</strong>
        </label>
        <input
          id="start-date"
          type="date"
          value={startDate}
          onChange={e => onStartDateChange(e.target.value)}
          min={today}
          style={{ width: '100%', padding: '0.5rem', border: '1px solid #ccc', borderRadius: '4px' }}
        />
      </div>

      <div style={{ marginBottom: '1rem' }}>
        <label htmlFor="end-date" style={{ display: 'block', marginBottom: '0.5rem' }}>
          <strong>End Date (inclusive, optional)</strong>
        </label>
        <input
          id="end-date"
          type="date"
          value={endDate || ''}
          onChange={e => onEndDateChange(e.target.value || null)}
          min={startDate}
          style={{ width: '100%', padding: '0.5rem', border: '1px solid #ccc', borderRadius: '4px' }}
        />
        <div style={{ fontSize: '0.85rem', color: '#666', marginTop: '0.25rem' }}>
          Leave empty to include all future shifts
        </div>
      </div>

      <div
        style={{
          padding: '1rem',
          backgroundColor: '#f0f8ff',
          border: '1px solid #4a90e2',
          borderRadius: '4px',
          marginBottom: '1rem',
        }}
      >
        <strong>ℹ️ Example:</strong> To set rates for all of December, use Start Date: Dec 1 and End Date: Dec
        31. Both dates are included in the update.
      </div>

      <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '0.5rem' }}>
        <Button kind="neutral" onClick={onCancel} disabled={loading}>
          Cancel
        </Button>
        <Button kind="primary" onClick={onNext} disabled={loading || !startDate}>
          {loading ? 'Loading...' : 'Get Rate Ranges'}
        </Button>
      </div>
    </div>
  )
}
